import type { AxiosError } from 'axios';
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

// Utils
import { get } from '@/utils/client';

// Types
import type { NotificationType } from '@/hooks/context/toast/types';

// Routes
import { NOTIFICATIONS_LAST_NEW } from '@/routes/apiEndpoints';

export type dataToastsNotificationsProps = {
    data: {
        notifications: NotificationType[];
        total_unread: number;
    };
};

const useToastsNotifications = (options?: SWRConfiguration) => {
    const {
        data,
        mutate: mutateToastsNotifications,
        error: toastsNotificationsError
    } = useSWR<dataToastsNotificationsProps, AxiosError<Error>>(
        NOTIFICATIONS_LAST_NEW,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    const toastsNotifications = data?.data?.notifications ?? [];
    const unreadNotifications = data?.data?.total_unread;

    return {
        toastsNotifications,
        unreadNotifications,
        hasUnreadNotifications: typeof unreadNotifications === 'number' && unreadNotifications > 0,
        mutateToastsNotifications,
        toastsNotificationsError,
        isLoading: !toastsNotifications && !toastsNotificationsError
    };
};
export default useToastsNotifications;
